<template>
  <div class="learning-path-suggested-courses">
    <ListTable
      :items="learningPath.suggested_courses"
      :columns="columns"
      :activeColumns="activeColumns"
      :hideHeaderMenus="true"
    >
      <template v-slot:col_distributor_cost="{ item }">{{
        item.distributor_cost | cost
      }}</template>
      <template v-slot:list-menu="{ item, id }">
        <ContextMenu
          :id="`${id}-menu`"
          :items="getContextMenu(item)"
          align="right"
        />
      </template>
    </ListTable>
  </div>
</template>

<script>
import ListTable from "components/listings/Table";
import EnrollmentMixin from "mixins/Courses/HandlesCourseEnrollment";
import CourseDetailsModal from "../Courses/DetailsModal";
import NoUpcomingEventsNotice from "./NoUpcomingEventsNotice";
export default {
  mixins: [EnrollmentMixin],
  components: {
    ListTable,
    CourseDetailsModal,
    NoUpcomingEventsNotice,
  },
  props: {
    learningPath: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    columns() {
      let columns = [];
      columns.push({ key: "name", label: "Course" });
      columns.push({ key: "total_hours", label: "Hours" });
      columns.push({ key: "category", label: "Category" });
      if (this.$root.isAdminager) {
        columns.push({ key: "distributor_cost", label: "Cost" });
      } else {
        columns.push({ key: "type_label", label: "Type" });
      }
      return columns;
    },
    activeColumns() {
      return this.columns.map((column) => column.key);
    },
  },
  methods: {
    getContextMenu(course) {
      let menu = [];
      if (!!course.is_online) {
        if (!!course.can_launch && !!course.launch_url) {
          menu.push({
            label: "Launch",
            action: () => {
              this.goToUrl(course.launch_url, true);
            },
          });
        } else if (!!course.show_prereq_notice) {
          menu.push({
            label: "Launch",
            action: () => {
              this.showPrerequisiteNotice();
            },
          });
        }
        if (!!course.can_enroll) {
          menu.push({
            label: "Register Myself",
            action: () => {
              this.enrollMyself(course);
            },
          });
        }
        if (!!course.can_enroll_others) {
          menu.push({
            label: "Register Others",
            action: () => {
              this.enrollOthers(course);
            },
          });
        }
      } else if (!!course.is_classroom && course.num_events > 0) {
        menu.push({
          label: "Upcoming Events",
          action: () => {
            this.viewDetails(course, "events");
          },
        });
      } else if (!!course.is_classroom) {
        menu.push({
          label: "Upcoming Events",
          action: () => {
            this.showNoUpcomingEventsNotice(course);
          },
        });
      }
      menu.push({
        label: "View Details",
        action: () => {
          this.viewDetails(course);
        },
      });
      return menu;
    },
    viewDetails(course, tab) {
      tab = tab || "details";
      this.$modal(CourseDetailsModal, { course: course, tab: tab })
        .then(() => {})
        .catch(() => {});
    },
    showNoUpcomingEventsNotice(course) {
      this.$modal(NoUpcomingEventsNotice, { course: course })
        .then(() => {
          this.$nextTick(() => {
            this.viewDetails(course, "downloads");
          });
        })
        .catch(() => {});
    },
  },
};
</script>